/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SyncStatus = "ACTIVE" | "BLOCKED" | "CANCELLED" | "DUPLICATE" | "NEW" | "PENDING" | "REJECTED" | "%future added value";
export type AnimalStatus_animal = {
    readonly id: string;
    readonly status: SyncStatus;
    readonly currentLicence: {
        readonly id: string;
        readonly status: SyncStatus;
        readonly isLifetime: boolean;
        readonly expiryDate: string | null;
    } | null;
    readonly " $refType": "AnimalStatus_animal";
};
export type AnimalStatus_animal$data = AnimalStatus_animal;
export type AnimalStatus_animal$key = {
    readonly " $data"?: AnimalStatus_animal$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AnimalStatus_animal">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "AnimalStatus_animal",
        "selections": [
            (v0 /*: any*/),
            (v1 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Licence",
                "kind": "LinkedField",
                "name": "currentLicence",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isLifetime",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expiryDate",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "LicensingAnimal",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '7be82d2ba6156151aae2f3b2e2e22579';
export default node;
